import { RJSFSchema, UiSchema } from "@rjsf/utils";
import { customizeValidator } from "@rjsf/validator-ajv8";
import JSONSchemaForm from "@rjsf/bootstrap-4";
import { useContext, useEffect, useState } from "react";
import customFormats from "@beeldit/core/custom-validations/custom-validation";
import useProcessSchema from "@beeldit/core/hooks/useProcessSchema";
import widgets from "@beeldit/core/widgets/widgets";
import { ConfigurationsContext } from "@main/contexts/ConfigurationsContext";
import projectWidgets from "@main/projectWidgets";
import { ButtonGroup, ToggleButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CategorySelector from "@beeldit/ecommerce/categories/components/CategorySelector";
import AttributeSelector from "@beeldit/ecommerce/attributes/components/AttributeSelector";
import MultidimensionalCustomFormTemplate from "@beeldit/core/templates/MultidimensionalCustomFormTemplate";

interface Prop {
  formConfig: {
    formRef: any;
    onSubmit: any;
    context: any;
    className?: string;
    showColor?: any;
    showCategory?: any;
  };
  formFilterValues?: any;
}

interface Context {
  element: any;
  setElement: (element: any) => any;
  selectedLang: string;
  setSelectedLang: (lang: string) => any;
  backendFormErrors: any;
}

function TagForm(props: Prop) {
  const { t } = useTranslation();
  const { formRef, onSubmit, context, className, showColor, showCategory } =
    props.formConfig;

  const {
    element,
    setElement,
    selectedLang,
    setSelectedLang,
    backendFormErrors,
  } = useContext<Context>(context);

  const { langs } = useContext<any>(ConfigurationsContext);

  const [finalSchema, setFinalSchema] = useState<RJSFSchema>({});
  const [finalUiSchema, setFinalUiSchema] = useState<UiSchema>({});

  const translations = {
    name: t("name"),    
  };

  let schema: any = {
    type: "object",
    properties: {
      name: {
        title: "",
        type: "object",
        properties: {},
      },      
    },
  };

  const uiSchema: UiSchema = {
    "ui:classNames": className,
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    name: {},    
  };

  const handleChange = (type: any) => {
    /** Este método de momento es necesario aunque en realidad no tenga sentido, pero se debe a un bug de la libreria */
    // Actualizar el estado solo si no hay errores de validación
    setElement(type.formData);
    return console.log.bind(console, type);
  };
  const log = (type: any) => {
    return console.log.bind(console, type);
  };

  const formats = customFormats;
  const validator = customizeValidator({ customFormats: formats });

  const processSchemaFunction = useProcessSchema();

  const setSchemaLangFields = () => {
    let new_names: any = {};

    for (let lang of langs) {
      new_names[lang] = {
        type: "string",
        title: t("name"),
      };
      if (selectedLang != lang) {
        uiSchema["name"][lang] = { "ui:widget": "hidden" };
      }
    }
    schema.properties.name.properties = new_names;
    setFinalSchema(processSchemaFunction(schema, element));
    setFinalUiSchema(uiSchema);
  };

  useEffect(() => {
    setSchemaLangFields();
  }, [langs, element, selectedLang]);

  const formTemplate = MultidimensionalCustomFormTemplate;

  return (
    <>
      <div className="text-right mb-3">
        {
          <ButtonGroup>
            {langs.map((lang: string, index: number) => (
              <ToggleButton
                key={index}
                id={`category-${index}`}
                type="radio"
                variant="outline-primary"
                name="radio"
                value={lang}
                checked={selectedLang === lang}
                onChange={(e) => setSelectedLang(e.currentTarget.value)}
              >
                {t(lang)}
              </ToggleButton>
            ))}
          </ButtonGroup>
        }
      </div>
      <JSONSchemaForm
        noHtml5Validate
        showErrorList={false}
        ref={formRef}
        templates={{
          ObjectFieldTemplate: formTemplate,
        }}
        schema={finalSchema}
        uiSchema={finalUiSchema}
        formData={element}
        validator={validator}
        onChange={handleChange}
        onSubmit={onSubmit}
        onError={log("errors")}
        extraErrors={backendFormErrors}
      />
    </>
  );
}

export default TagForm;
